import qs from 'qs';
import instance from '../axios';

export const createNewBag = (idBatch, type) => {
  const createBagBody = {
    type
  }
  return instance.post(`/bag/batch/${idBatch}/`, createBagBody);
};

export const openBag = (idBag) => {
  return instance.put(`/bag/${idBag}/open`);
}

export const closeBag = (idBag) => {
  return instance.put(`/bag/${idBag}/close`);
}

export const getBag = (idBag) => {
  return instance.get(`/bag/${idBag}`);
}

export const getBagSummarized= (idBag) => {
  return instance.get(`/bag/${idBag}/summarized`);
}

export const addRoute = (idBag, idRoute) => {
  const assingRouteBody = {
    route_id: idRoute,
  }
  return instance.put(`/bag/${idBag}/addRoute`, assingRouteBody );
}

export const getBagContents = (idBag) => {
  return instance.get(`/bag/${idBag}/content`);
}
